import { render, staticRenderFns } from "./IncomeCategory.vue?vue&type=template&id=4c7238de&scoped=true&"
import script from "./IncomeCategory.vue?vue&type=script&lang=js&"
export * from "./IncomeCategory.vue?vue&type=script&lang=js&"
import style0 from "./IncomeCategory.vue?vue&type=style&index=0&id=4c7238de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7238de",
  null
  
)

export default component.exports